import set from 'transmute/set';
import { COLUMN_NAMES } from '../../constants/Table';
import { DEAL_PROPERTIES } from '../../constants/CrmSearchConstants';
import { isVisibleGridProperty
// @ts-expect-error untyped
} from 'crm_data/properties/GridProperties';
import { fromPropertyGroups } from '../options';
import { getPropertyLabel } from 'customer-data-property-utils/PropertyDisplay';
export const getPropertyGroupsAsOptions = (propertyGroups, isWeightedOrTotalPortalConfig, hasDealTagsAccess) => {
  const propertyGroupsWithFilteredProperties = propertyGroups.map(propertyGroup => {
    const visibleProperties = propertyGroup.properties.filter(property => {
      if (property.name === COLUMN_NAMES.DEAL_TAGS) {
        return hasDealTagsAccess && isVisibleGridProperty(null, property);
      }

      // We filter our certain options based on the portal config
      if (isWeightedOrTotalPortalConfig) {
        return isVisibleGridProperty(null, property) && property.name !== COLUMN_NAMES.FORECAST_AMOUNT && property.name !== COLUMN_NAMES.FORECAST_PROBABILITY;
      }
      return isVisibleGridProperty(null, property);
    });
    return set('properties', visibleProperties, propertyGroup);
  });
  return fromPropertyGroups(propertyGroupsWithFilteredProperties);
};
export const getSelectedColumns = (columns, properties, selectedForecastType) => {
  var _selectedForecastType;
  const amountProperty = (_selectedForecastType = selectedForecastType === null || selectedForecastType === void 0 ? void 0 : selectedForecastType.amountProperty) !== null && _selectedForecastType !== void 0 ? _selectedForecastType : COLUMN_NAMES.AMOUNT;
  return columns.map(propertyName => {
    const property = properties[propertyName];
    const immovableColumns = [DEAL_PROPERTIES.DEAL_NAME, amountProperty];
    return {
      disabled: immovableColumns.includes(propertyName),
      readOnly: immovableColumns.includes(propertyName),
      text: getPropertyLabel(property),
      value: propertyName
    };
  }).filter(({
    text
  }) => !!text);
};